var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "content-sitegate-design-form" },
    [
      _c("h5", { staticClass: "mt-4" }, [_vm._v("Image Settings")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-2",
            label: "Image tint strength",
            "label-for": "input-2",
            "label-cols-sm": "4",
            "label-cols-lg": "3",
          },
        },
        [
          _c("b-form-input", {
            attrs: { type: "range", min: "1", max: "100", step: "1" },
            model: {
              value: _vm.form.imageTintStrength,
              callback: function ($$v) {
                _vm.$set(_vm.form, "imageTintStrength", $$v)
              },
              expression: "form.imageTintStrength",
            },
          }),
          _vm._v("\n    " + _vm._s(_vm.form.imageTintStrength) + "%\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-2",
            label: "Image tint style",
            "label-for": "input-2",
            "label-cols-sm": "4",
            "label-cols-lg": "3",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.imageTintStyleOptions },
            model: {
              value: _vm.form.imageTintStyle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "imageTintStyle", $$v)
              },
              expression: "form.imageTintStyle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-2",
            label: "Image and content direction",
            description:
              "A row layout will place the image and content side by side. A column layout selection will display the image above the content.",
            "label-for": "input-2",
            "label-cols-sm": "4",
            "label-cols-lg": "3",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.modalContentDirectionOptions },
            model: {
              value: _vm.form.modalContentDirection,
              callback: function ($$v) {
                _vm.$set(_vm.form, "modalContentDirection", $$v)
              },
              expression: "form.modalContentDirection",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.contentSettings.primaryButtonActive ||
      _vm.contentSettings.secondaryButtonActive
        ? _c("section", [
            _c("h5", { staticClass: "mt-4" }, [_vm._v("Buttons Settings")]),
            _vm._v(" "),
            _c("hr"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.contentSettings.primaryButtonActive
        ? _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-2",
                label: "Primary Button Type",
                "label-for": "input-2",
                "label-cols-sm": "4",
                "label-cols-lg": "3",
              },
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.buttonTypeOptions },
                model: {
                  value: _vm.form.primaryLinkButtonType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "primaryLinkButtonType", $$v)
                  },
                  expression: "form.primaryLinkButtonType",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contentSettings.primaryButtonActive
        ? _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-2",
                label: "Primary Button Icon",
                "label-for": "input-2",
                "label-cols-sm": "4",
                "label-cols-lg": "3",
              },
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.buttonIconOptions },
                model: {
                  value: _vm.form.primaryLinkButtonIcon,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "primaryLinkButtonIcon", $$v)
                  },
                  expression: "form.primaryLinkButtonIcon",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contentSettings.secondaryButtonActive
        ? _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-2",
                label: "Secondary Button Type",
                "label-for": "input-2",
                "label-cols-sm": "4",
                "label-cols-lg": "3",
              },
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.buttonTypeOptions },
                model: {
                  value: _vm.form.secondaryLinkButtonType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "secondaryLinkButtonType", $$v)
                  },
                  expression: "form.secondaryLinkButtonType",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contentSettings.secondaryButtonActive
        ? _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-2",
                label: "Secondary Button Icon",
                "label-for": "input-2",
                "label-cols-sm": "4",
                "label-cols-lg": "3",
              },
            },
            [
              _c("b-form-select", {
                attrs: { options: _vm.buttonIconOptions },
                model: {
                  value: _vm.form.secondaryLinkButtonIcon,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "secondaryLinkButtonIcon", $$v)
                  },
                  expression: "form.secondaryLinkButtonIcon",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }